import _JSXStyle from "styled-jsx/style";
import { colors, theme } from '@dhis2/ui-constants';
import { IconCross16 } from '@dhis2/ui-icons';
import PropTypes from 'prop-types';
import React from 'react';
import i18n from '../locales/index.js';

const createClickHandler = onClick => event => {
  onClick({}, event);
};

export const CloseButton = _ref => {
  let {
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement("button", {
    title: i18n.t('Close modal dialog'),
    "data-test": "dhis2-modal-close-button",
    onClick: createClickHandler(onClick),
    "aria-label": i18n.t('Close modal dialog'),
    className: _JSXStyle.dynamic([["80232614", [colors.grey700, colors.grey200, colors.grey900, colors.grey200, theme.focus, colors.grey300]]])
  }, /*#__PURE__*/React.createElement(IconCross16, null), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "80232614",
    dynamic: [colors.grey700, colors.grey200, colors.grey900, colors.grey200, theme.focus, colors.grey300]
  }, ["button.__jsx-style-dynamic-selector{background-color:transparent;color:".concat(colors.grey700, ";border:none;outline:none;padding:4px 4px 0px;border-radius:3px;position:absolute;top:0px;inset-inline-end:0px;}"), "button.__jsx-style-dynamic-selector:hover{background-color:".concat(colors.grey200, ";color:").concat(colors.grey900, ";}"), "button.__jsx-style-dynamic-selector:focus{background-color:".concat(colors.grey200, ";outline:3px solid ").concat(theme.focus, ";}"), "button.__jsx-style-dynamic-selector:focus.__jsx-style-dynamic-selector:not(:focus-visible){outline:none;}", "button.__jsx-style-dynamic-selector:active{background-color:".concat(colors.grey300, ";}")]));
};
CloseButton.propTypes = {
  onClick: PropTypes.func
};